<script lang="ts">
  import { _ } from 'svelte-i18n';
  import Label from '../typography/Label.svelte';
  import Heading from '../typography/Heading.svelte';
  import CoinV2 from '../icons/CoinV2.svelte';

  export let amount: string = '';
</script>

<div class="available-balance__body">
  <div class="available-balance__balance">
    <Heading
      color="#FFF"
      class="available-balance__amount {$$props.class || ''}"
    >
      {@html amount}
    </Heading>
    <span class="available-balance__amount__icon">
      <CoinV2 color="#FFFFFFcc" size="18" />
    </span>
  </div>
  <Label
    type="medium-regular"
    color="rgba(255, 255, 255, 0.8)"
    class="available-balance__balance__title"
  >
    {$_('header.balance_title')}
  </Label>
</div>

<style lang="scss">
  :global(.available-balance__amount) {
    font-weight: bold !important;
    margin-right: 4px !important;
    display: flex !important;
    align-items: center;
  }

  .available-balance {
    &__body {
      align-items: center;
      flex-flow: column nowrap;
      display: flex;
      width: 100%;
    }

    &__balance {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__amount__icon {
      display: inline-block;
      vertical-align: middle;
      max-height: 18px;
    }
  }
</style>
